import { Ticket, OperationType } from "./Entity";

export class Exchange extends Ticket {
  // Dados Carteira
  portfolioName: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioDocument: string = null;
  portfolioCode: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // - Dados da Contraparte
  counterpartName: string = null;
  command = "0";

  // Dados da Operação
  operationTypeId: OperationType = null;
  currencyName: string = null;
  operationValue: number = null;
  currencyQuotation: number = null;

  parityPl: string = null;
  parityMtm: string = null;
  settlementDate: Date = null;
  tradingPlace: string = null;
  settlementPlace: string = null;
  appealDate: Date = null;
  expirationDate: Date = null;
  contractSaleSettlementDate: Date = null;
  currencyAmount: number = null;
  annotations: string = null;

  constructor() {
    super();
  }
}
